<div class="login-container">
  <div class="login-card-wrapper">
    <mat-card class="login-card">
      <mat-card-content>
        <div class="logo-section">
          <div class="logo-icon">
            <mat-icon>local_parking</mat-icon>
          </div>
          <h1 class="gradient-text">Urbix Admin</h1>
          <p class="subtitle">Панель управління паркуванням</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Логін</mat-label>
            <input matInput formControlName="login" autocomplete="username">
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Пароль</mat-label>
            <input matInput 
                   [type]="hidePassword ? 'password' : 'text'" 
                   formControlName="password"
                   autocomplete="current-password">
            <mat-icon matPrefix>lock</mat-icon>
            <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          @if (error) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              {{ error }}
            </div>
          }

          <button mat-raised-button 
                  type="submit" 
                  class="login-button"
                  [disabled]="!loginForm.valid || loading">
            @if (loading) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              Увійти
            }
          </button>
        </form>

        <div class="demo-info">
          <mat-icon>info</mat-icon>
          <div>
            <strong>Демо доступ:</strong><br>
            Логін: admin | Пароль: admin123
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
